<div class="main" [class]="isInline ? 'is-widget' : ''">
    <header id="header" class="header" [attr.data-testid]="headerId" role="banner">
        <nav class="header__content" [attr.data-testid]="navigationId" role="navigation" aria-label="Hovednavigation">
            @if (!isInline) {
                <a
                    id="skip-button"
                    class="skip-link"
                    href="#main-content"
                    (click)="skipToContent($event)"
                    [attr.title]="getDictionaryItem('skipToMainContent')"
                    [attr.aria-label]="getDictionaryItem('skipToMainContent')"
                    tabindex="0"
                >
                    <span>{{ getDictionaryItem("skipToMainContent") }}</span>
                </a>
            }

            @if (!isInline) {
                <a [routerLink]="['/']" class="header__logo" aria-label="Gå til forsiden">
                    <img [src]="'./assets/images/softvaerket.png'" alt="Softværket Logo" />
                </a>
            }

            <div class="h2" id="header-headline">
                <span>
                    {{ getActiveCompany() }}
                </span>
            </div>

            <div class="header__end-wrapper">
                @if (userAccounts?.length !== 1) {
                    <app-account-picker class="account-picker-desktop" [accounts]="userAccounts"></app-account-picker>
                }
                @if (userContact) {
                    <app-user-profile [user]="userContact"></app-user-profile>
                }
            </div>
        </nav>
    </header>

    @if (messages.length && messages && isLoggedIn && userAccounts) {
        <div class="message-center-wrapper" role="region" aria-label="Beskedcenter">
            @for (message of messages; track message.id) {
                <app-message-center [data]="message" [state]="messageCenterState"></app-message-center>
            }
        </div>
    }

    <main id="main-content" [class]="messages.length && isLoggedIn && userAccounts ? 'content content--top-small' : 'content content--top'" role="main">
        @if (!isLoggedIn && loginTimer) {
            <div
                class="full-screen-overlay"
                role="dialog"
                aria-labelledby="login-dialog-title"
                aria-describedby="login-dialog-description"
                cdkTrapFocus
                [cdkTrapFocusAutoCapture]="true"
            >
                <h2 id="login-dialog-title" class="sr-only">{{ getDictionaryItem("loginToApp") }}</h2>
                <p id="login-dialog-description" class="sr-only">Log ind for at få adgang til applikationen.</p>
                <button
                    mat-button
                    class="cta-button"
                    (click)="login()"
                    type="button"
                    role="button"
                    id="login-button"
                    [attr.aria-label]="getDictionaryItem('loginToApp')"
                    [attr.data-testid]="loginButtonId"
                >
                    <span> {{ getDictionaryItem("loginToApp").toLocaleUpperCase() }} </span>
                </button>
            </div>
        }

        @if (errorMessage.length && userAccountErrorTimer) {
            <div
                class="full-screen-overlay"
                role="dialog"
                aria-labelledby="error-dialog-title"
                aria-describedby="error-dialog-description"
                cdkTrapFocus
                [cdkTrapFocusAutoCapture]="true"
            >
                <div class="no-accounts-popup">
                    <h2 id="error-dialog-title">{{ errorHeader }}</h2>
                    <p id="error-dialog-description">{{ errorMessage }}</p>
                    <button
                        mat-button
                        class="cta-button"
                        (click)="logout()"
                        type="button"
                        role="button"
                        [attr.aria-label]="getDictionaryItem('logoutFromApp')"
                        [attr.data-testid]="logoutButtonId"
                    >
                        <span> {{ getDictionaryItem("logoutFromApp").toLocaleUpperCase() }} </span>
                    </button>
                </div>
            </div>
        }

        @if (userAccounts) {
            <router-outlet></router-outlet>
        }
    </main>

    @if (!isInline) {
        <footer id="footer" class="footer" role="contentinfo">Copyright © 2024 Softværket. All rights reserved.</footer>
    }
</div>
